"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _index = require("../index");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _copyfield_styles = _interopRequireDefault(require("./copyfield_styles"));

var _copyfield_definition = _interopRequireDefault(require("./copyfield_definition"));

var _definecomponent = require("../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
/* ========== ~~~~~~~~~~ EXPORT : COPY FIELD ~~~~~~~~~~ ========== */


var CopyField = (0, _reactJss.default)(_copyfield_styles.default)(function (props) {
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      copied = _useState2[0],
      setCopied = _useState2[1];

  var handleCopy = function handleCopy(e) {
    var validField = props.fieldType === 'textarea' || props.fieldType === 'textfield';
    var copyfield = e.target.closest('.copyfield').querySelector(".".concat(validField ? props.fieldType : 'textarea'));
    copyfield.select();
    document.execCommand('copy');
    props.handleCopy && props.handleCopy(copyfield.value, e);
    setCopied(true);
    setTimeout(function () {
      setCopied(false);
    }, 3000);
  };

  var handleSelect = function handleSelect(e) {
    e.target.select();
  };

  var showLink = function showLink() {
    return !!props.link;
  };

  var renderLink = function renderLink() {
    if (showLink()) return _react.default.createElement(_index.Link, {
      name: props.link.name,
      type: 'external',
      variant: 'primary',
      text: props.link.text,
      operation: 'link',
      behavior: 'none',
      action: props.link.url,
      color: 'primary',
      handleClick: props.handleLinkClick
    });
  };

  return _react.default.createElement("div", {
    className: "copyfield ".concat(props.classes.copyfield, " copyfieldName-").concat(props.name, " fieldHeight-").concat(props.height, " ctaPosition-").concat(props.ctaPosition, " copied-").concat(copied)
  }, props.fieldType === 'textfield' ? _react.default.createElement(_index.TextField, {
    type: 'text',
    handleFocus: handleSelect,
    value: props.defaultValue,
    name: props.name,
    disabled: props.fieldDisabled,
    readOnly: props.readOnly
  }) : _react.default.createElement(_index.TextAreaField, {
    type: 'textarea',
    nowrap: props.nowrap,
    scrollbarColor: props.scrollbarColor,
    handleFocus: handleSelect,
    value: props.defaultValue,
    name: props.name,
    disabled: props.fieldDisabled,
    readOnly: props.readOnly
  }), _react.default.createElement("div", {
    className: "buttonlink show-link-".concat(showLink())
  }, _react.default.createElement(_index.CTAs, null, _react.default.createElement(_index.Button, {
    name: 'copycta',
    type: 'action',
    variant: props.ctaVariant,
    text: copied ? 'Copied to Clipboard!' : 'Copy',
    icon: props.icon,
    operation: 'link',
    behavior: 'none',
    handleClick: handleCopy,
    disabled: props.buttonDisabled,
    iconRight: props.iconRight
  })), renderLink()));
});
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */

(0, _definecomponent.defineComponent)(CopyField, _copyfield_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = CopyField;
exports.default = _default;